"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeRegExp = (input) => input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
exports.default = exports.escapeRegExp;
//# sourceMappingURL=escape_reg_exp.js.map